import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProgramGeneratorProgressStore } from 'src/store/programGeneratorProgressStore';
import './Overview.scss';
import { ReactComponent as CreateWithManualIcon } from '../../../../../../assets/images/onboarding-trainer/dashboard/overview/create-with-manual.svg';
import { ReactComponent as CreateWithAIIcon } from '../../../../../../assets/images/onboarding-trainer/dashboard/overview/create-with-ai.svg';
import { ReactComponent as CreateArrowIcon } from '../../../../../../assets/images/onboarding-trainer/dashboard/overview/create-arrow.svg';
import { ReactComponent as LogoIcon } from '../../../../../../assets/images/onboarding-trainer/logo.svg';

export const Overview: FC = () => {
  const navigate = useNavigate();
  const resetProgress = useProgramGeneratorProgressStore((state) => state.resetProgress);

  const handleCreate = (type: 'ai' | 'manual') => {
    resetProgress();
    navigate(`/onboarding-trainer/dashboard/program-generator/${type}`);
  };

  return (
    <div className="overview-container">
      <div className="dashboard-header-center">
        <div className="logo-center">{<LogoIcon />}</div>
        <h1>{'Create personalized workout programs for your clients'}</h1>
      </div>

      <div className="dashboard-action-cards">
        {/* Create with AI Card */}
        <button className="action-card ai-card" onClick={() => handleCreate('ai')}>
          <div className="icon-circle">{<CreateWithAIIcon viewBox="0 0 64 64" />}</div>
          <div className="card-title">
            {'Create with AI'}
            {<CreateArrowIcon />}
          </div>
          <p className="card-description">{'Let AI generate a customized workout program'}</p>
        </button>

        {/* Create Manually Card */}
        <button className="action-card manual-card" onClick={() => handleCreate('manual')}>
          <div className="icon-circle">{<CreateWithManualIcon viewBox="0 0 64 64" />}</div>
          <div className="card-title">
            {'Create Manually'}
            {<CreateArrowIcon />}
          </div>
          <p className="card-description">{'Build your workout program from scratch'}</p>
        </button>
      </div>

      {/* <button className="single-workout-btn" onClick={() => console.log('Single Workout')}>
        {'Or Create a Single Workout'}
        {<CreateArrowIcon />}
      </button> */}
    </div>
  );
};
